module.exports = __webpack_public_path__ + "img/support_b2.9034b99e.png";